import { createIntl, createIntlCache } from 'react-intl';
import messages_es from "./es.json";
import '@formatjs/intl-numberformat/polyfill';
import '@formatjs/intl-numberformat/locale-data/es';
import '@formatjs/intl-datetimeformat/polyfill';
import '@formatjs/intl-datetimeformat/locale-data/es';

export const messages = {
    'es': messages_es
};

export const language = 'es';

const cache = createIntlCache();
export const intl = createIntl({ locale: language, messages: messages[language] }, cache);


// WEBPACK FOOTER //
// ./source/locales/localesConfig.js